import React from 'react';

const PtPRT: React.FC = () => (
  <svg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ flexShrink: 0 }}>
    <path d='M0 0H6.4V12H0V0Z' fill='#006600' />
    <path d='M6.4 0H16V12H6.4V0Z' fill='#FF0000' />
    <circle cx='6.4' cy='6' r='2.5' stroke='#FFCC00' />
    <path d='M4.9 4H7.9V6.5C7.9 7.3 7.2 8 6.4 8C5.6 8 4.9 7.3 4.9 6.5V4Z' fill='white' stroke='#FF0000' strokeWidth='0.6' />
    <path
      d='M6.1 4.7H6.7V5.3H6.1V4.7ZM5.4 5.5H6V6.1H5.4V5.5ZM6.8 5.5H7.4V6.1H6.8V5.5ZM6.1 5.5H6.7V6.1H6.1V5.5ZM6.1 6.4H6.7V7H6.1V6.4Z'
      fill='#003399'
    />
  </svg>
);

export default PtPRT;
